import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { WebhookService } from './webhook.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-webhook',
  templateUrl: './webhook.component.html',
  styleUrls: ['./webhook.component.scss']
})
export class WebhookComponent {

  public isLoaded: boolean = true;

  public webhook = new FormGroup({
    urlDeposito: new FormControl<string>(''),
    urlSaque: new FormControl<string>('')
  });

  constructor(private webhookService: WebhookService, private toastr: ToastrService)
  {
    this.loadScreen();
  }

  private getWebHookDeposit(){
    this.webhookService.getWebhookDeposit().then((value) =>{
      this.webhook.controls.urlDeposito.setValue(value.url);
    });
  }

  private getWebHookWithDraw(){
    this.webhookService.getWebhookWithDraw().then((value) =>{
      this.webhook.controls.urlSaque.setValue(value.url);
    });
  }

  private loadScreen()
  {
    this.isLoaded = false;
    this.getWebHookDeposit();
    this.getWebHookWithDraw();
    this.isLoaded = true;
  }

  public changeWebHook()
  {
    this.isLoaded = false;

    this.webhookService.changeWebhookDeposit(this.webhook.controls.urlDeposito.value!).then(()=>
    {
      this.webhookService.changeWebhookWithDraw(this.webhook.controls.urlSaque.value!).then(()=>
      {
        this.isLoaded = true;
        this.toastr.success("WebHook alterado!",'Sucesso!',{
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }).catch(()=>{
        this.isLoaded = true;
        this.toastr.error("Erro ao cadastrar webhook!",'Erro',{
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      })
    }).catch(()=>{
      this.isLoaded = true;
      this.toastr.error("Erro ao cadastrar webhook!",'Erro',{
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
    });
  }
}
